export const GET_STUDENT_PROFILE_REQUEST = 'GET_STUDENT_PROFILE_REQUEST'
export const GET_STUDENT_PROFILE_FAIL = 'GET_STUDENT_PROFILE_FAIL'
export const GET_STUDENT_PROFILE_SUCCESS = 'GET_STUDENT_PROFILE_SUCCESS'

export const REASSIGN_STUDENT_ROOM_REQUEST = 'REASSIGN_STUDENT_ROOM_REQUEST'
export const REASSIGN_STUDENT_ROOM_FAIL = 'REASSIGN_STUDENT_ROOM_FAIL'
export const REASSIGN_STUDENT_ROOM_SUCCESS = 'REASSIGN_STUDENT_ROOM_SUCCESS'

export const REMOVE_STUDENT_ROOM_REQUEST = 'REMOVE_STUDENT_ROOM_REQUEST'
export const REMOVE_STUDENT_ROOM_FAIL = 'REMOVE_STUDENT_ROOM_FAIL'
export const REMOVE_STUDENT_ROOM_SUCCESS = 'REMOVE_STUDENT_ROOM_SUCCESS'

export const RESET_REASSIGN_STUDENT_ROOM = 'RESET_REASSIGN_STUDENT_ROOM'
